import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="bg-[#050048]">
      <div className="mx-auto max-w-6xl px-5 py-12 sm:px-8">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
          <div>
            <Logo light />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/60">
              This page replaces the access-request email. One link, every channel.
            </p>
          </div>

          <div className="flex flex-col gap-2.5 text-sm">
            <span className="text-[11px] font-semibold uppercase tracking-[0.16em] text-white/50">
              Contact
            </span>
            <a
              data-testid="footer-mailto-pep"
              href="mailto:pep@smartmarketer.com"
              className="font-medium text-white transition-colors hover:text-pink"
            >
              pep@smartmarketer.com
            </a>
            <a
              data-testid="footer-mailto-agency"
              href="mailto:agency@smartmarketer.com"
              className="font-medium text-white transition-colors hover:text-pink"
            >
              agency@smartmarketer.com
            </a>
            <a
              data-testid="footer-site-link"
              href="https://smartmarketeragency.com"
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-white transition-colors hover:text-pink"
            >
              smartmarketeragency.com
            </a>
          </div>
        </div>

        <div className="mt-10 border-t border-white/10 pt-6 text-xs text-white/50">
          © {new Date().getFullYear()} Smart Marketer Agency. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
